/**
 * The exact Microsoft/Better-Auth callback URL for a Helm instance's host.
 * Pure string formatting only -- no validation, and no dependency on
 * anything server-only, so both sides of the process boundary can import
 * it: @hub/server/entra-redirects (callbackFor) validates the host and
 * then calls this to build the same string it registers with Graph;
 * @hub/ui/InstanceDetailPage calls it directly to display and copy that
 * same URI for an already-validated host, with no need to re-derive or
 * re-validate it.
 *
 * Before this existed, the UI hardcoded the literal path itself, twice in
 * the same block (the displayed `<code>` and the Copy button) -- two
 * copies that could drift from each other with nothing to catch it. This
 * is now the one place the literal path is written.
 */
export function entraCallbackUri(host: string): string {
  return `https://${host}/api/auth/callback/microsoft`;
}
